import { combineReducers } from "redux";
import { UserReducer } from "../reducers/UserReducer";
import { PlanReducer } from "../reducers/PlanReducer";
import { AdminReducer } from "../reducers/AdminReducer";

export default combineReducers({
    UserReducer,PlanReducer,AdminReducer
});